import { render, staticRenderFns } from "./EmailBase.vue?vue&type=template&id=8618f5e6&scoped=true&"
import script from "./EmailBase.vue?vue&type=script&lang=js&"
export * from "./EmailBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8618f5e6",
  null
  
)

export default component.exports